export default __webpack_public_path__ + "static/media/gallery-image-1-full.edd00d34.jpg";